import React, { useEffect, useMemo, useState } from "react";
import * as S from "./FollowUpCall.style";
import * as P from "../../../../utils/pipes";
import { useTranslation } from "react-i18next";
import Popup from "reactjs-popup";
import ZaiaImage from "../../../zaiaComponents/zaiaImage";
import FlorenzSelect from "../../../florenzComponents/florenzSelect/FlorenzSelect";
import FlorenzButton from "../../../florenzComponents/florenzButton";
import { useTwilioClient } from "../../../../hooks/useTwilioClient";
import ZaiaReaction from "../../../zaiaComponents/zaiaReaction";

const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;

function FollowUpCall({
  userPicture,
  phoneStartCall,
  setPhoneStartCall,
  patient,
  doctor,
  userToProcess,
  twilioClient,
  speakerDevices,
  microphoneDevices,
  selectedSpeaker,
  selectedMicrophone,
  setSelectedSpeaker,
  setSelectedMicrophone
}){

  const {t, i18n: { language }} = useTranslation("global");
  const [isCalling, setIsCalling] = useState(true);
  const [callAccepted, setCallAccepted] = useState(false);
  const [callEnded, setCallEnded] = useState(false);
  const [callDenied, setCallDenied] = useState(false);  

  const {
    callHistory,
    clientName,
    isCallActive,
    callTimer,
    callStatus,
    startupClient,
    finishClient,
    makeOutgoingCall,
    hangupCall,
    fetchCallHistory,
    isMuted,
    toggleMute,
    updateSpeakerDevice,
    updateRingtoneDevice,
    transcription,
    isProcessingTranscript,
  } = twilioClient;

  const [newCallStart, setNewCallStart] = useState(true);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    startupClient();
    return () => {
      setNewCallStart(false)
      finishClient();
    }
  }, []);

  useEffect(() => {
    if(phoneStartCall){
      makeOutgoingCall(
        `+${phoneStartCall?.countryCode}${phoneStartCall?.number}`,
        patient.id,
        doctor.id,
        userToProcess.id  
      )
    }
  }, [phoneStartCall]);

  // Actualizar dispositivo de audio seleccionado

  const selectSpeaker = (e) => {    
    setSelectedSpeaker(e);
    updateSpeakerDevice(e);
  }

  const selectMicrophone = (e) => {
    setSelectedMicrophone(e);
    updateRingtoneDevice(e);
  }  

  return (
    <S.FollowUpCall>
      {
        (
          (
            callStatus === "ringing" ||
            callStatus === "connecting" ||
            callStatus === "open"
          ) 
        ) &&
        <>
          <div className="call">
            <div className="patient-image">
              <ZaiaImage
                img={userPicture}
                rounded={true}
                size={156}
              />
            </div>
            <div className="call__info">
              <div className="call__container">
                <div className="call__left">
                  <div className="call__name">
                    {phoneStartCall?.label && phoneStartCall?.name} <b>{phoneStartCall?.label}</b> {phoneStartCall?.label && "De"} {patient?.name} {patient?.lastname}
                  </div>
                  <div className="call__number">
                    {`+${phoneStartCall?.countryCode} ${phoneStartCall?.number}`}
                  </div>
                  <div className="call__program">
                    {P.dataTranslation(userToProcess?.process.processName, language)}
                  </div>
                  {
                    callStatus === "open" &&
                    <div className="call__duration">
                      {callTimer}
                    </div>
                  }
                </div>
                <div className="call__right">
                  {
                    callStatus === "open" &&
                    <div className="record-microphone">
                      {/* coso */}
                    </div>
                  }
                </div>
              </div>
              <div className="call__container">
                <div className="call__calling">
                  {
                    callStatus === "open" 
                    ? t("followUp.onCall") 
                    : t("followUp.calling") + "..."
                  }
                </div>
                <div className="call__buttons">
                  <button className={`call__button ${isMuted && "call__button--muted"}`}
                    onClick={() => {
                      toggleMute();
                    }}
                  >
                    <i className={`button__icon icon ${isMuted ? "zaia-i-mic-off" : "zaia-i-mic-on"}`}></i> 
                  </button>
                  <button className="call__button call__button--red"
                    onClick={() => {
                      hangupCall();
                    }}
                  >
                    <i className="button__icon icon zaia-i-phone"></i> 
                  </button>
                  <div className="button-separator"></div>
                  {
                    <Popup
                      trigger={
                        <button className="call__button">
                          <i className="button__icon icon zaia-i-manage-account"></i> 
                        </button>
                      }
                      keepTooltipInside
                      nested
                      position={"center bottom"}
                      on="click"
                      
                    >
                      <S.CallSettings>
                        <div className="header">
                          <i className="header__icon icon zaia-i-filters"></i>
                          <div className="header__text">
                            {t("followUp.callSettings")}
                          </div>
                        </div>
                        <div className="selects">
                          <div className="select">
                            <FlorenzSelect
                              label={t("followUp.audio")}
                              xsSize={true}
                              forWhiteBackgroud={true}
                              items={
                                speakerDevices.map((device) => (
                                  {
                                    value: device.deviceId || t("global.audioWithoutName"),
                                    text: device.label || t("global.audioWithoutName")
                                  }
                                ))
                              }
                              value={selectedSpeaker}
                              setValue={selectSpeaker}
                            />
                          </div>
                          <div className="select">
                            <FlorenzSelect 
                              label={t("followUp.microphone")}
                              xsSize={true}
                              forWhiteBackgroud={true}
                              items={
                                microphoneDevices.map((device) => (
                                  {
                                    value: device.deviceId || t("global.microphoneWithoutName"),
                                    text: device.label || t("global.microphoneWithoutName")
                                  }
                                ))
                              }
                              value={selectedMicrophone}
                              setValue={selectMicrophone}
                            />
                          </div>
                        </div>
                      </S.CallSettings>
                    </Popup>
                  }
                </div>
              </div>
            </div>
          </div>
        </>
      }
      {
        callDenied &&
        <div className="call">
          <div className="call__left">
            <div className="patient-image patient-image--denied">
              <ZaiaImage
                img={userPicture}
                rounded={true}
                size={118}
              />
              <div className="patient-image__denied">
                <i className="patient-image__denied-icon icon zaia-icono-cerrar"></i>
              </div>
            </div>
            <div className="call__name">
              {phoneStartCall?.label && phoneStartCall?.name} <b>{phoneStartCall?.label}</b> {phoneStartCall?.label && "De"} {patient?.name} {patient?.lastname} {"No contesto"}
            </div>
            <div className="call__number">
              {`+${phoneStartCall?.countryCode} ${phoneStartCall?.number}`}
            </div>
            <div className="call__program">
              {P.dataTranslation(userToProcess?.program?.processName, language)}
            </div>
        </div>
          <div className="call__right">
            <div className="buttons-denied">
              <div className="button-denied">
                <FlorenzButton
                  typeStyle={"secondary"}
                  text={t("followUp.callLater")}
                  widthComplete={true}
                  onClick={() => {
                    setPhoneStartCall(null);
                  }}
                />
              </div>
              <div className="button-denied">
                <FlorenzButton
                typeStyle={"secondary"}
                text={t("followUp.callAgain")}   
                onClick={
                  () => {
                    
                }}
              />
              </div>
            </div>
          </div>
        </div>
      }
      {
        !isCallActive && 
        (
          callStatus === "closed" ||
          callStatus === "no-answer" ||
          callStatus === "busy" ||
          callStatus === "failed" ||
          callStatus === "canceled" ||
          callStatus === "unknown" ||
          callStatus === "completed"
        ) &&
        <div className="call-ended">
          <div className="call-ended__top">
            <div className="call-ended__left">
              <div className="patient-image">
                <ZaiaImage
                  img={userPicture}
                  rounded={true}
                  size={51}
                />
              </div>
              <div className="patient-info">
                <div className="patient-info__name">
                  {phoneStartCall?.label && phoneStartCall?.name} <b>{phoneStartCall?.label}</b> {phoneStartCall?.label && "De"} {patient?.name} {patient?.lastname}
                </div>
                <div className="patient-info__number">
                  {`+${phoneStartCall?.countryCode} ${phoneStartCall?.number}`}
                </div>
              </div>
            </div>
            <div className="call-ended__right"> 
              <div className="call-ended__status">
                {t("followUp.callEnded")}
              </div>
            </div>
          </div>
          <div className="call-ended__bottom">
            <div className="call-ended__buttons">
              <div className="call-ended__buttons__left">
              </div>
              <div className="call-ended__buttons__right">
                <div className="call-ended__button call-ended__button--right">
                  <FlorenzButton
                    typeStyle={"primary"}
                    size="s"  
                    text={t("followUp.backToPatientInfo")}     
                    onClick={
                      () => {
                        setPhoneStartCall(null);
                      }
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          { 
            <div className="summary">
              <div className="summary__title">
                {t("followUp.callSummary")}
                <button 
                  className="copy-btn" 
                  onClick={() => {
                    const text = transcription.map(entry => {
                      const isDoctor = entry.persona.includes("0");
                      const label = isDoctor ? t("globally.patient") : t("globally.doctor");
                      return `${label}: ${entry.mensaje}`;
                    }).join("\n");
                    navigator.clipboard.writeText(text).then(() => {
                      setIsCopied(true);
                      setTimeout(() => setIsCopied(false), 2000);
                    });
                  }}
                  title={t("button.copy") || "Copiar"}
                >
                  {isCopied ? (
                    <><i className="icon zaia-i-check-1" /> Copiado</>
                  ) : (
                    <><i className="icon zaia-i-copy" /> Copiar</>
                  )}
                </button>
              </div>
              {
                isProcessingTranscript &&
                <div className="summary__loading">
                  <ZaiaReaction
                    widthimg="40px"
                    zaiaImg={logoZaiaLoading}
                  /> 
                </div>
              }
              <div className="summary__text">
                {transcription.map((entry, index) => {
                  const isDoctor = entry.persona.includes("0");

                  return (
                    <div
                      key={index}
                      style={{
                        textAlign: isDoctor ? "left" : "right",
                        marginBottom: "3px"
                      }}
                    >
                      <div className="label-message">
                        {isDoctor ? t("globally.patient") : t("globally.doctor")}
                      </div>
                      <div
                        className="message"
                      >{entry.mensaje}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          }
        </div>
      }
    </S.FollowUpCall>
  );
}


export default FollowUpCall;
